// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"db103b84","239":"1f93bdcc","453":"52155906","732":"cbb92b70"}[chunkId] + ".chunk.js";
};